var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilePdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0138 1L20.0154 9.00154V22.2041C20.0154 23.7508 18.7615 25.0046 17.2148 25.0046H2.81207C1.26538 25.0046 0.0115356 23.7508 0.0115356 22.2041V3.80054C0.0115356 2.25384 1.26538 1 2.81207 1H12.0138Z",
    fill: "#E94848"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34005 9.80164C8.81561 9.80164 8.38431 10.2329 8.38431 10.7574C8.38431 11.4093 8.74655 12.2187 9.128 12.9795C8.82984 13.9128 8.49149 14.9131 8.05877 15.7571C7.90203 15.8186 7.7483 15.8773 7.59879 15.9344C6.9034 16.1999 6.29919 16.4306 5.90835 16.7457C5.90095 16.7533 5.89397 16.7612 5.88745 16.7696C5.71391 16.947 5.61267 17.1886 5.61267 17.4475C5.61267 17.972 6.04397 18.4033 6.56841 18.4033C6.82415 18.4033 7.07099 18.3079 7.24937 18.1255C7.25555 18.1208 7.26153 18.1158 7.26729 18.1106C7.61685 17.6932 8.02902 16.936 8.39626 16.2439C9.24264 15.911 10.1297 15.5722 10.9857 15.3688C11.6106 15.8724 12.5146 16.2051 13.2586 16.2051C13.783 16.2051 14.2143 15.7738 14.2143 15.2493C14.2143 14.7249 13.783 14.2936 13.2586 14.2936C12.662 14.2936 11.795 14.5066 11.1321 14.7297C10.5947 14.2252 10.1011 13.5952 9.74624 12.9257C9.7846 12.8075 9.82393 12.6894 9.86307 12.5718C10.0826 11.9123 10.2958 11.2716 10.2958 10.7574C10.2958 10.2329 9.8645 9.80164 9.34005 9.80164ZM9.34005 10.3751C9.55459 10.3751 9.72235 10.5428 9.72235 10.7574C9.72235 11.0442 9.56874 11.5724 9.39083 12.1402C9.1531 11.5878 8.95776 11.0578 8.95776 10.7574C8.95776 10.5428 9.12552 10.3751 9.34005 10.3751ZM10.4959 14.9061C10.1284 14.5284 9.79178 14.1029 9.50432 13.6457C9.30438 14.2542 9.09317 14.8721 8.82933 15.4676C9.37559 15.2596 9.92912 15.061 10.4959 14.9061ZM13.2586 14.867C13.4731 14.867 13.6409 15.0348 13.6409 15.2493C13.6409 15.4639 13.4731 15.6316 13.2586 15.6316C12.8279 15.6316 12.2157 15.4372 11.7264 15.1657C12.2881 15.0069 12.901 14.867 13.2586 14.867ZM6.83119 17.7313C7.01805 17.5059 7.2852 17.0581 7.55396 16.5784C6.99958 16.8003 6.51181 17.0082 6.28761 17.1817C6.22897 17.2463 6.18606 17.3466 6.18606 17.4475C6.18606 17.6621 6.35383 17.8298 6.56836 17.8298C6.68244 17.8298 6.76735 17.7923 6.83119 17.7313Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0154 9.00159H14.9559C13.4092 9.00159 12.0139 7.60629 12.0139 6.0596V1.00005L20.0154 9.00159Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 11.6138,
    y: 0.199846,
    width: 8.80169,
    height: 8.80169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.400077
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.200038
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/file-pdf.085c0d86ad97f7a5bf20eeeacdadb237.svg";
export { ForwardRef as ReactComponent };